import axios from 'axios'
import { logSearchError } from '../../listings-client/util/clientLogger'
import { generatePhoneBookCall } from './queries/generatePhoneBookCall'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'
import { get } from 'lodash'

export const generatePhoneBookNumber = (phoneBookInput) => {
  if (Object.keys(phoneBookInput).length > 0) {
    return new Promise((resolve, reject) => {
      axios({
        url: getGraphURL({ operationName: 'generatePhoneBookCall' }),
        method: 'post',
        data: {
          query: generatePhoneBookCall,
          variables: { request: phoneBookInput },
        },
        headers: {
          'apollographql-client-name': `${APOLLO_CLIENT_NAME}`,
          'apollographql-client-version': get(
            window,
            'PCLN_BOOTSTRAP_DATA.appInfo.appVersion',
            'development'
          ),
        },
      })
        .then((response) => resolve(response?.data?.data?.phoneBookAirEntry))
        .catch((error) => {
          logSearchError('phoneBookCall', error)
          reject(error)
        })
    })
  } else {
    return Promise.resolve('phoneBookInput empty')
  }
}
